// Expo.jsx
import React, { useEffect, useMemo, useRef, useState } from "react";
import axios from "axios";
import "./APartnerAgr.scss";
import { customerService } from "../../services";
import { connect } from "react-redux";

function Apartner({ profile }) {

    const customerLS = useMemo(() => {
        try {
            const raw = localStorage.getItem("customer");
            return raw ? JSON.parse(raw) : null;
        } catch {
            return null;
        }
    }, []);


    const searchParams = new URLSearchParams(window.location.search);
    const pageTypeRaw = (searchParams.get("type") || "pocket").toLowerCase();
    const pageType = "apartner";
    const inputClass = "apartnerCodeInput";
    const [initDone, setInitDone] = useState(false);
    const [notFoundCustomer, setNotFoundCustomer] = useState(null); // null | true | false

    const [amwayNumber, setAmwayNumber] = useState(null);
    const [partyId, setPartyId] = useState(null);

    const [redeemCodeByType, setRedeemCodeByType] = useState(new Map());
    const [allowInput, setAllowInput] = useState(false);
    const [apiRedeemed, setApiRedeemed] = useState(false);

    const [codeDigits, setCodeDigits] = useState(["", "", "", ""]);
    const inputsRef = useRef([]);
    const [errorText, setErrorText] = useState("");

    const expectedCode = useMemo(() => redeemCodeByType.get(pageType) || "", [redeemCodeByType, pageType]);
    const code = useMemo(() => codeDigits.join(""), [codeDigits]);
    const isCodeComplete = useMemo(() => codeDigits.every((d) => d !== ""), [codeDigits]);

    const expectedCodes = useMemo(
        () => redeemCodeByType.get(pageType) || [],
        [redeemCodeByType, pageType]
    );

    const isValid = useMemo(() => {
        return isCodeComplete && expectedCodes.includes(code);
    }, [isCodeComplete, expectedCodes, code]);

    const focusInput = (idx = 0) => {
        const el = inputsRef.current[idx];
        if (el && typeof el.focus === "function") el.focus();
    };


    const fetchStaff = async () => {
        const res = await axios.post(`${process.env.REACT_APP_API_URL}/customers/expo_staff`, {});
        const rows = Array.isArray(res.data) ? res.data : [];
        const map = new Map();

        rows.forEach((r) => {
            const clean = String(r.amwayNumber || "").replace(/\D/g, "");
            const type = String(r.type).toLowerCase();
            if (clean.length !== 4) return;
            if (!map.has(type)) { map.set(type, []); }
            map.get(type).push(clean);
        });

        setRedeemCodeByType(map);
    };

    useEffect(() => {
        if (customerLS?.amwayNumber && !amwayNumber) {
            setAmwayNumber(customerLS.amwayNumber);
        }
        if (customerLS?.partyId && !partyId) {
            setPartyId(customerLS.partyId);
        }
    }, [customerLS, amwayNumber, partyId]);

    const apartnerPageRef = useRef(null);

    useEffect(() => {
        if (!initDone) return;
        if (!isCodeComplete) return;

        const el = apartnerPageRef.current;
        if (el) el.scrollTop = 0;
    }, [initDone, isCodeComplete]);

    const fetchCustomer = async () => {
        if (!profile?.userId) return;
        const c = await customerService.get(profile.userId);
        if (!c?.uid) {
            setNotFoundCustomer(true);
            setInitDone(true);
            return;
        }

        setAmwayNumber(c.amwayNumber);
        setPartyId(c.partyId);

        const res = await axios.post(`${process.env.REACT_APP_API_URL}/customers/expo`, {
            uid: c.uid,
            amwayNumber: c.amwayNumber,
            partyId: c.partyId,
            type: pageType,
        });

        const logs = Array.isArray(res.data?.customerLog) ? res.data.customerLog : [];
        const hasMAll = logs.some((l) => String(l.type || "").toUpperCase() === "AALL");


        const customer = Array.isArray(res.data?.customer) ? res.data.customer : [];
        const hasRight = customer.some((x) => String(x.type).toLowerCase() === pageType);
        const redeemed = logs.some((l) => String(l.type).toLowerCase() === pageType);

        setAllowInput(hasRight);
        setApiRedeemed(redeemed);

        // tri-state: ถ้าไม่มีสิทธิ์ -> notfound true, ถ้ามีสิทธิ์ -> false
        setNotFoundCustomer(!hasRight);

        setInitDone(true);
        if (!hasMAll && hasRight === false) {
            window.location.replace("/APartnerAgr");
            return;
        }
    };

    const handleKeyDown = (idx, e) => {
        if (e.key !== "Backspace") return;

        // ถ้ามีตัวเลขในช่องนี้ -> ลบตัวนี้
        if (codeDigits[idx]) {
            const next = [...codeDigits];
            next[idx] = "";
            setCodeDigits(next);
            return;
        }

        // ถ้าไม่มีตัวเลขในช่องนี้ -> ย้อนกลับไปช่องก่อนหน้า
        if (idx > 0) {
            const next = [...codeDigits];
            next[idx - 1] = "";
            setCodeDigits(next);
            focusInput(idx - 1);
        }
    };

    useEffect(() => {
        const img = new Image();
        img.src = "/images/apartner/apartner-loading.png";
    }, []);

    useEffect(() => {
        document.body.classList.add("apartner-body");
    }, []);

    useEffect(() => {
        if (!profile?.userId) return;

        const init = async () => {
            try {
                await fetchStaff();
                await fetchCustomer();
            } finally {
                setTimeout(() => focusInput(0), 0);
            }
        };

        init();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [profile?.userId, pageType]);

    const handleDigitChange = (idx, e) => {
        const v = e.target.value.replace(/\D/g, "").slice(-1);
        const next = [...codeDigits];
        next[idx] = v;
        setCodeDigits(next);
        if (v && idx < 3) focusInput(idx + 1);
    };

    const clearAll = () => {
        setCodeDigits(["", "", "", ""]);
        setTimeout(() => focusInput(0), 0);
    };

    const handleEnter = async () => {
        if (apiRedeemed) return;
        if (!isCodeComplete) return;

        // กรอกครบแต่ไม่ตรง -> เคลียร์ทั้งหมด
        if (!isValid) {
            setErrorText("รหัสไม่ถูกต้อง");
            clearAll();
            return;
        }

        try {
            setErrorText("");
            await axios.post(`${process.env.REACT_APP_API_URL}/customers/expo_pass`, {
                uid: profile.userId,
                amwayNumber,
                partyId,
                type: pageType,
                code: code
            });

            setApiRedeemed(true);
        } catch (e) {
            setErrorText("เกิดข้อผิดพลาด กรุณาลองใหม่");
            clearAll();
        }
    };

    // ====== CLASS คุมภาพพื้นหลัง ======
    const stateClass = !initDone
        ? "state-loading"
        : apiRedeemed
            ? "state-base"
            : isCodeComplete
                ? "state-base"
                : "state-base";

    return (


        <div className={`apartnerWrapper wr-${pageType}`}>
            <div ref={apartnerPageRef} className={`apartnerPage type-${pageType} ${stateClass}`}>

                {(initDone && (allowInput === false || allowInput === true) && (notFoundCustomer === false || notFoundCustomer === true)) && (
                    <>
                        <div className={`apartnerCirclePanel ${notFoundCustomer === true ? "notfound" : apiRedeemed ? "redeemed" : ""}`}>
                            <img
                                className={`apartnerCircleTextImage ${apiRedeemed ? "redeemed" : ""}`}

                                src={
                                    notFoundCustomer === true
                                        ? "/images/apartner/apartner-notfound.png"
                                        : apiRedeemed
                                            ? "/images/apartner/apartner-redeemed.png"
                                            : "/images/apartner/apartner-firstredeem.png"
                                }
                                alt="รับของที่ระลึก"
                            />

                            {((!apiRedeemed && notFoundCustomer === false) || (apiRedeemed === false && notFoundCustomer === false)) && (
                                <>
                                    <div className="apartnerCircleLine" />

                                    <div className="apartnerRow">
                                        {codeDigits.map((d, i) => (
                                            <input
                                                key={i}
                                                ref={(el) => (inputsRef.current[i] = el)}
                                                className={inputClass}
                                                type="password"
                                                inputMode="numeric"
                                                pattern="[0-9]*"
                                                maxLength={1}
                                                value={d}
                                                onChange={(e) => handleDigitChange(i, e)}
                                                onKeyDown={(e) => handleKeyDown(i, e)}
                                            />
                                        ))}
                                    </div>
                                </>
                            )}
                        </div>

                        {((!apiRedeemed && notFoundCustomer === false) || (apiRedeemed === false && notFoundCustomer === false)) && (
                            <button
                                type="button"
                                className={`apartnerSubmitBtn ${isCodeComplete ? "enabled" : "disabled"}`}
                                disabled={!isCodeComplete}
                                onClick={handleEnter}
                            >
                                รับของที่ระลึก
                            </button>
                        )}
                    </>
                )}

                {initDone && errorText && (
                    <div className="apartnererrorText">{errorText}</div>
                )}
            </div>
        </div>
    );


}

export default connect((s) => ({ profile: s.profile }))(Apartner);
